import React from 'react'
import classNames from 'classnames'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import VidyardPlayButton from '@toasttab/shared/src/components/molecules/VidyardPlayButton/VidyardPlayButton'
import { VideoProps } from './Video.d'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import VidyardVideoPlayer from '@toasttab/shared/src/components/molecules/VidyardVideo/VidyardVideoPlayer'
import VideoAnimation from '../VideoAnimation/VideoAnimation'

const Video = ({
  buttonVariation,
  callback,
  classes,
  componentStyleContext,
  heapInteraction,
  fullBleed,
  image,
  imageClasses,
  imageVidyardFallback,
  inverseButton,
  labelOutside,
  labelClasses,
  numComponents = 1,
  playButtonClasses,
  sectionHeading,
  vidyardId
}: VideoProps) => {
  const pageContext = usePageContext()
  const handleClick = async () => {
    if (typeof window !== 'undefined') {
      // @ts-ignore - Typescript defs missing for @vidyard/embed-code
      const vidyardEmbed = await import('@vidyard/embed-code')
      if (vidyardEmbed.api) {
        const players = vidyardEmbed.api.getPlayersByUUID(vidyardId)
        if (players && players.length > 0) {
          const index = players.findIndex((player: any) =>
            player.hasOwnProperty('showLightbox')
          )
          players[index].showLightbox()
          if (callback) {
            callback()
          }
        }
      }
    }
  }

  const renderPlayButton = () => {
    if (vidyardId) {
      if (labelOutside) {
        return (
          <div className='flex items-center justify-center'>
            <VidyardPlayButton
              classes={playClasses}
              onClick={handleClick}
              size='large'
              variation={
                image || imageVidyardFallback || buttonVariation
                  ? btnVariation
                  : 'blue'
              }
            />
            <span className={labelCss}>{sectionHeading}</span>
          </div>
        )
      } else {
        return (
          <VidyardPlayButton
            classes={playClasses}
            interactionId={heapInteraction}
            label={sectionHeading}
            onClick={handleClick}
            size='large'
            variation={
              image || imageVidyardFallback || buttonVariation
                ? btnVariation
                : 'blue'
            }
          />
        )
      }
    }
  }

  const wrapperCss = classNames(
    classes,
    'ds-video flex-wrap items-center justify-center relative',
    {
      'content-center inline-flex': !image && !imageVidyardFallback,
      flex: image || imageVidyardFallback
    }
  )
  const buttonClass = `${
    pageContext.styleContext !== 'hpSnowflake' ? 'absolute z-[1]' : ''
  }`
  const playClasses = classNames(playButtonClasses, buttonClass)

  const previewMp4 = image?.[0]?.url?.split('.').pop() === 'mp4'

  let btnVariation = buttonVariation
  if (!btnVariation) {
    btnVariation = inverseButton ? 'inverse-primary' : 'blue-primary'
  }

  const labelCss = labelClasses || 'text-secondary'

  return (
    <div
      className={wrapperCss}
      data-testid={`video${numComponents ? `-${numComponents}` : ''}`}
    >
      {renderPlayButton()}
      {image ? (
        previewMp4 ? (
          <VideoAnimation
            animation={{ url: image[0].url }}
            autoPlay
            classes={imageClasses ? imageClasses : 'rounded-lg'}
            componentStyleContext={componentStyleContext}
            fullBleed={fullBleed}
            loop
            showPlayButton={false}
          />
        ) : (
          <Image
            classes=''
            imageAlt=''
            imgClasses={imageClasses}
            lazyLoad={image[0].lazyLoad}
            optimizedImages={image[0].optimizedImages}
            url={image[0].url}
          />
        )
      ) : null}
      {!image && imageVidyardFallback ? (
        <img
          alt=''
          className={imageClasses}
          src={`https://play.vidyard.com/${vidyardId}.jpg`}
        />
      ) : null}
      <div className='hidden'>
        <VidyardVideoPlayer vidyardId={vidyardId} />
      </div>
    </div>
  )
}

export default Video
